import { render, staticRenderFns } from "./PassthroughGet.vue?vue&type=template&id=a93d3d42"
import script from "./PassthroughGet.vue?vue&type=script&lang=js"
export * from "./PassthroughGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports